import { useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import ModalButton from './ModalButton';
import { ReactComponent as HelpIcon } from '../../icons/info-circle-solid.svg';
import Modal from './Modal';
import './HelpModal.scss';

const HelpModal = ({ title, description, children }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const renderDescription = () => {
    if (!description || !Array.isArray(description)) return null;
    return description.map((paragraph, index) => <p key={index}>{paragraph}</p>);
  };

  return (
    <>
      <button type="button" className={cx('HelpTrigger', { text: children })} onClick={() => setIsOpen(true)}>
        {children ? children : <Icon icon={<HelpIcon />} />}
      </button>

      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} title={title} className="HelpModal">
        <div className="description">{renderDescription()}</div>
        <ModalButton block className="got-it" onClick={() => setIsOpen(false)}>
          {t('common.gotIt')}
        </ModalButton>
      </Modal>
    </>
  );
};

export default HelpModal;
